import { createSelector } from 'reselect'

import { IOnboardingState } from '../models'

export const selectActionsData = (state: { onboarding: IOnboardingState }) =>
  state.onboarding.actionsData

export const selectActionsLoadingStatus = createSelector(
  [selectActionsData],
  ({ status }) => status
)
